import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-1 -mb-1">
    <motion.span
      className={"block " + className}
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const MaskedLineInView = ({ children, delay = 0, className = "" }) => (
  <motion.span
    className="block overflow-hidden pb-1 -mb-1"
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.4 }}
  >
    <motion.span
      className={"block " + className}
      variants={{ hidden: { y: "115%" }, show: { y: "0%", transition: { duration: 0.9, delay, ease: EASE } } }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export const PalestineFlag = ({ className = "" }) => (
  <svg viewBox="0 0 24 16" className={className} aria-hidden="true">
    <rect width="24" height="16" fill="#111" />
    <rect y="5.33" width="24" height="5.34" fill="#f7f7f7" />
    <rect y="10.67" width="24" height="5.33" fill="#149144" />
    <path d="M0 0 L11 8 L0 16 Z" fill="#CE1126" />
  </svg>
);

export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="gk" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#E8C96A" />
        <stop offset="1" stopColor="#B8942C" />
      </linearGradient>
    </defs>
    <path d="M32 5C22.5 19 14 29.5 14 41a18 18 0 0 0 36 0C50 29.5 41.5 19 32 5Z" stroke="url(#gk)" strokeWidth="2.6" />
    <path d="M32 25c-4.2 6.4-7.5 10.6-7.5 15.3a7.5 7.5 0 0 0 15 0C39.5 35.6 36.2 31.4 32 25Z" fill="url(#gk)" />
  </svg>
);
